import { useCallback, useState } from 'react';

/**
 * Toggle hook with stable handlers. Useful for modals, drawers, dropdowns.
 */
export const useToggle = (initial = false): [boolean, () => void, (next: boolean) => void] => {
  const [value, setValue] = useState(initial);
  const toggle = useCallback(() => setValue((v) => !v), []);
  return [value, toggle, setValue];
};
